module.exports = __webpack_public_path__ + "img/tornado.8af0a919.svg";